// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { DefaultConfig } from '../../settings/config'
import ToastMessage from '../../components/toast-messages'
import toast from 'react-hot-toast'
import axios from "axios"
import { ApiUrls } from '../../utility/ApiUrls'
import GlobalVariable from '../../settings/global'
import { clarity } from 'react-microsoft-clarity'
import Cookies from 'universal-cookie'


const baseApiUrl = GlobalVariable.BASE_API_URL
const chunkSize = 1048576 * 10
let getUserCall = false
const myEncodeURIComponent = DefaultConfig().myEncodeURIComponent

const getToken = () => {
  const expiryTimestamp = localStorage.getItem('expiryTime')
  if (!expiryTimestamp) {
    return false
  }
  const now = new Date().getTime()
  if (now > parseInt(expiryTimestamp, 10)) {
    return false
  }

  return true
}

let callUiConfiguration = false
const apiCall = async (method, endpoint, data) => {
  // console.log(method, endpoint, data)
  const authAxios = DefaultConfig().authAxios
  const token = getToken()
  if (!token && !callUiConfiguration) {
    callUiConfiguration = true
    console.log('Configuration data has expired')
    axios.get(`${GlobalVariable.hostpath}api/Common/GetUIConfiguration`)
      .then((res) => {
        const result = res.data
        callUiConfiguration = false
        if (result) {
          const data = result.data
          if (data) {
            const azureAdB2C = data.azureAdB2C
            const merchantOne = data.merchantOne
            const JsScriptData = data.jsScriptData
            azureAdB2C['apiUrl'] = GlobalVariable.hostpath
            azureAdB2C['hostname'] = window.location.origin
            localStorage.setItem('azureAdB2C', JSON.stringify(azureAdB2C))
            localStorage.setItem('merchantOne', JSON.stringify(merchantOne))
            localStorage.setItem('JsScriptData', JSON.stringify(JsScriptData))
            const expiryTimestamp = new Date().getTime() + (data.expiryTime * 60 * 1000)
            localStorage.setItem('expiryTime', expiryTimestamp)

            axios.get(`${GlobalVariable.hostpath}api/User/GetUser`, {
              headers: { Authorization: `Bearer ${localStorageToken}` }
            }).then((res) => {
              const userData = res.data
              if (userData.success) {
                if (userData.data) {
                  if (window.location.hostname !== 'localhost') {
                    const msClarityId = localStorage.getItem('JsScriptData') ? JSON.parse(localStorage.getItem('JsScriptData'))['msClarityId'] : ''
                    clarity.init(msClarityId)
                    clarity.identify('USER_ID', { userProperty: userData.data.email })
                    clarity.setTag('Email', userData.data.email)
                    clarity.consent()
                  }
                  if (userData.data.isResetPassword === true) {
                    toast(t => (<ToastMessage t={t} message={"Your password has been changed successfully. Please Login..."} status={"success"} />))
                    setTimeout(() => {
                      localStorage.clear()
                      window.location.reload()
                    }, 3000)
                  } else {
                    const cookies = new Cookies()
                    cookies.set('CustomClaims', res.headers["x-set-cookie"], { path: '/' })
                    localStorage.setItem('userData', JSON.stringify(userData.data))
                  }
                }
              } else {
                toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                localStorage.clear()
                window.location.reload()
              }
            }).catch((error) => {
              const errorresponse = error.response
              if (errorresponse) {
                const status = errorresponse.status
                if (status === 403 || status === 401) {
                  localStorage.clear()
                  window.location.reload()
                } else if (status === 406) {
                  // setError(true)
                  window.location.reload()
                } else if (status === 412) {
                  const AzureB2CLogoutUrl = `${azureAdB2C.instance}/${azureAdB2C.domain}/${azureAdB2C.signUpSignInPolicyId}/oauth2/v2.0/logout?post_logout_redirect_uri=${azureAdB2C.hostname}&client_id=${localStorage.getItem('token')}`
                  localStorage.clear()
                  window.location.href = AzureB2CLogoutUrl
                } else if (status === 417 || status === 424) {
                  if (count !== 2) {
                    setCount(count + 1)
                  }
                  if ((count + 1) === 3) {
                    const AzureB2CLogoutUrl = `${azureAdB2C.instance}/${azureAdB2C.domain}/${azureAdB2C.signUpSignInPolicyId}/oauth2/v2.0/logout?post_logout_redirect_uri=${azureAdB2C.hostname}&client_id=${localStorage.getItem('token')}`
                    localStorage.clear()
                    window.location.href = AzureB2CLogoutUrl
                  }
                } else {
                  toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                  setTimeout(() => {
                    localStorage.clear()
                    window.location.reload()
                  }, 2000)
                }
              }
            })
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 404) {
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
          }
        }
      })
  }
  if (method === 'get') {
    return await authAxios.get(endpoint)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 419) {
            if (!getUserCall) {
              getUserCall = true
              toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
              return ''
            }
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  } else if (method === 'post') {
    return await authAxios.post(endpoint, data)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 419) {
            if (!getUserCall) {
              getUserCall = true
              toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
              return ''
            }
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  } else if (method === 'patch') {
    return await authAxios.patch(endpoint, data)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  } else if (method === 'delete') {
    return await authAxios.delete(endpoint)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 419) {
            if (!getUserCall) {
              getUserCall = true
              toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
              return ''
            }
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  }
}

// Get Sales Invoices For Agent
export const getSalesInvoicesForAgent = createAsyncThunk("appCommonReducers/getSalesInvoicesForAgent", async (obj) => {
  const method = 'post'
  const endpoint = ApiUrls.GetSalesInvoicesForAgent
  const data = obj
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const workordersDto = resultData.transactions ? resultData.transactions : []
    // const recCount = resultData.totalItems
    // const gridSize = resultData.pageSize
    // const recCount = resultData.count
    const gridSize = data.pageSize
    return {
      data: workordersDto,
      //  recCount,
      gridSize,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

// Get Invoice Document
export const GetInvoiceDocument = createAsyncThunk("appCommonReducers/GetInvoiceDocument", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetInvoiceDocument}`
  const data = { AgentId: wdata.agentId, InvoiceId: wdata.documentNumber, WoId: wdata.WoId, SourceSystem: wdata.sourceSystem ? wdata.sourceSystem : '' }
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

// Get WO Document
export const GetWorkorderDocuments = createAsyncThunk("appCommonReducers/GetWorkorderDocuments", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetWorkorderDocuments}`
  const data = { AgentId: wdata.agentId, InvoiceId: wdata.documentNumber, WoId: wdata.WoId, SourceSystem: wdata.sourceSystem ? wdata.sourceSystem : '' }
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const getInvoiceListByAgent = createAsyncThunk("appCommonReducers/getInvoiceListByAgent", async (agentId) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetInvoiceListByAgent}`
  const data = {}
  data['agentIds'] = agentId
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetSalesInvoicesCountForAgent = createAsyncThunk("appCommonReducers/GetSalesInvoicesCountForAgent", async (obj) => {
  const method = 'post'
  const endpoint = ApiUrls.GetSalesInvoicesCountForAgent
  const data = obj
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    console.log(resultData, 'resultData')
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})
export const getPaymentHistory = createAsyncThunk("appCommonReducers/getPaymentHistory", async (obj) => {
  const method = 'post'
  const endpoint = ApiUrls.PaymentHistory
  const data = obj
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const workordersDto = resultData.transactions ? resultData.transactions : []
    workordersDto.forEach(transaction => {
      // Calculate total invoices and total amount for the current transaction
      const totalInvoices = transaction.invoiceCount
      const totalAmount = transaction.invoiceAmount

      // Add total invoices and total amount to the current transaction object
      transaction.totalInvoices = totalInvoices
      transaction.totalAmount = totalAmount
    })
    // const recCount = resultData.totalItems
    // const gridSize = resultData.pageSize
    const recCount = resultData.count
    const gridSize = data.pageSize
    return {
      data: workordersDto,
      recCount,
      gridSize,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const UpdateWorkorder = createAsyncThunk("appCommonReducers/UpdateWorkorder", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.UpdateWorkorder}`
  const data = wdata.obj
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    // const workorderData = resultData.workorderData
    return {
      // data: workorderData,
      data1: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetValidatedTransactionsInvoices = createAsyncThunk("appCommonReducers/GetValidatedTransactionsInvoices", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetValidatedTransactionsInvoices}`
  const data = wdata.obj
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    // const workorderData = resultData.workorderData
    return {
      // data: workorderData,
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetTransactionData = createAsyncThunk("appCommonReducers/GetTransactionData", async (txnId) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetTransactionById}?transactionsId=${txnId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const workorderData = resultData.workorderData
    return {
      data: workorderData,
      data1: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const getAccountDetailsForAgent = createAsyncThunk("appCommonReducers/getAccountDetailsForAgent", async (agentId) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetAccountDetailsForAgent}`
  const data = {}
  data['agentIds'] = agentId
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: {},
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetAgentAccountStatementPdf = createAsyncThunk("appCommonReducers/GetAgentAccountStatementPdf", async (plData) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetAgentAccountStatement}?agentNumber=${plData.agentId}&outputFormat=PDF&clientDepartment=${plData.lastRouteName === 'maritime' ? 'Maritime' : (plData.lastRouteName === 'seafarers' ? 'Seafarer' : 'Corporate')}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetAgentDetails = createAsyncThunk("appCommonReducers/GetAgentDetails", async (name) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetAgentDetails}?agent=${name}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  return resultData
})

export const getUserDetailsByEmailId = createAsyncThunk("appCommonReducers/getUserDetailsByEmailId", async (name) => {

  const method = 'post'
  const endpoint = `${ApiUrls.GetUserDetailsByEmailId}`
  const data = { email: name }
  const resultData = await apiCall(method, endpoint, data)
  return resultData
})

export const GetFRBByAgentNumber = createAsyncThunk("appCommonReducers/GetFRBByAgentNumber", async (agentId) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetFRBByAgentNumber}?agentNumber=${agentId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const CreateFRBWorkOrder = createAsyncThunk("appCommonReducers/CreateFRBWorkOrder", async (wdata) => {
  const method = 'post'
  const endpoint = `/${ApiUrls.CreateFRBWorkOrder}`
  const data = wdata.obj
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    // console.log(resultData)
    const workorderData = resultData.workorderData
    return {
      data: workorderData,
      data1: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const CancelRequestbyWorkorderId = createAsyncThunk("appCommonReducers/CancelRequestbyWorkorderId", async (woId) => {
  const method = 'get'
  const endpoint = `${ApiUrls.CancelRequestbyWorkorderId}?workOrderId=${woId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

// Create workorder

export const GetRequestQueuebyAgentNumber = createAsyncThunk("appCommonReducers/GetRequestQueuebyAgentNumber", async (agentId) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetRequestQueuebyAgentNumber}?clientNumber=${agentId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetFRBClientRoles = createAsyncThunk("appCommonReducers/GetFRBClientRoles", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetFRBClientRoles}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetAgentAccountStatement = createAsyncThunk("appCommonReducers/GetAgentAccountStatement", async (obj) => {
  const method = 'post'
  const endpoint = ApiUrls.GetSalesInvoicesForAgent
  const data = obj
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})


// Get Company Details in salesforce
// Get Agent Details Data
export const getAgentDetailsByAgentNo = createAsyncThunk("appCommonReducers/getAgentDetailsByAgentNo", async (wdata) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetAgentDetails}?agent=${wdata}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      tokenExp: false
    }
  }
})


// Impersonate User 
export const ImpersonateUser = createAsyncThunk("appCommonReducers/ImpersonateUser", async (email) => {
  const method = 'post'
  const endpoint = ApiUrls.ImpersonateUser
  const data = {}
  data['email'] = email
  const resultData = await apiCall(method, endpoint, data)
  if (resultData?.userData?.userAgents) {
    return {
      data: resultData.userData.userAgents,
      spinner: false,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: false,
      tokenExp: false
    }
  }
})

// Get Base Workorder Data
export const getBaseWorkorderData = createAsyncThunk("appCommonReducers/getBaseWorkorderData", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetBaseWorkOrderData}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      tokenExp: false
    }
  }
})

// Get Workorder Data


// Update Workorder Data

//Get Validated Transactions Invoices

export const GetContactDetails = createAsyncThunk("appCommonReducers/GetContactDetails", async (wdata) => {
  const method = 'post'
  const endpoint = `/${ApiUrls.GetContactDetails}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

// getallROles
export const GetAllGroups = createAsyncThunk("appCommonReducers/GetAllGroups", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetAllGroups}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetAllRoles = createAsyncThunk("appCommonReducers/GetAllRoles", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetAllRoles}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetVesselsByAgentId = createAsyncThunk("appCommonReducers/GetVesselsByAgentId", async (agentId) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetVesselsByAgentId}?clientNumber=${agentId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetFRPDetails = createAsyncThunk("appCommonReducers/GetFRPDetails", async (wdata) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetFRPDetails}?clientNumber=${wdata?.agentId}&officialNumber=${wdata?.officialNumber}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetBilltoPartyInformation = createAsyncThunk("appCommonReducers/GetBilltoPartyInformation", async (wdata) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetBilltoPartyInformation}?officialNumber=${wdata?.officialNumber}&clientId=${wdata?.agentId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const CreateFRPWorkOrder = createAsyncThunk("appCommonReducers/CreateFRPWorkOrder", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.CreateFRPWorkOrder}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

//sending the email to customer 
export const UnlistedUser = createAsyncThunk("appCommonReducers/UnlistedUser", async (wdata) => {

  const method = 'post'
  const endpoint = `/${ApiUrls.UnlistedUser}`
  const data = wdata.data
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    toast(t => (<ToastMessage t={t} message={resultData} status={"sucesss"} />))
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const SendFeedbackEmail = createAsyncThunk("appCommonReducers/SendFeedbackEmail", async (data) => {

  const method = 'post'
  const endpoint = `/${ApiUrls.SendFeedbackEmail}`
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    toast(t => (<ToastMessage t={t} message={resultData} status={"sucesss"} />))
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})
export const invoiceDownloadProgress = createAsyncThunk("appCommonReducers/invoiceDownloadProgress", async (newObj) => {
  return newObj
})

export const getStepNameStatus = createAsyncThunk("appCommonReducers/getStepNameStatus", async (name) => {
  return name
})
export const displayMenu = createAsyncThunk("appCommonReducers/displayMenu", async (displayMenuBool) => {
  return displayMenuBool
})
export const getClearStatus = createAsyncThunk("appCommonReducers/getClearStatus", async () => {
  return ''
})

export const getClearMultiStatus = createAsyncThunk("appCommonReducers/getClearMultiStatus", async () => {
  return ''
})

export const getClearPaymentStatus = createAsyncThunk("appCommonReducers/getClearPaymentStatus", async () => {
  return ''
})
export const tabStopper = createAsyncThunk("appCommonReducers/tabStopper", async (data) => {
  return data
})


export const getWoLoading = createAsyncThunk("appCommonReducers/getWoLoading", async (data) => {
  return data
})
export const getCompanyValue = createAsyncThunk("appCommonReducers/getCompanyValue", async (data) => {
  // console.log(data, 'data')
  return data
})
export const getClearStore = createAsyncThunk("appCommonReducers/getClearStore", async () => {
  return ''
})

export const getClearStoreData = createAsyncThunk("appCommonReducers/getClearStoreData", async () => {
  return ''
})

export const getClearFileData = createAsyncThunk("appCommonReducers/getClearFileData", async () => {
  return ''
})

export const removeneedinfodata = createAsyncThunk("appCommonReducers/removeneedinfodata", async () => {
  return ''
})

export const getFileExceed = createAsyncThunk("appCommonReducers/getFileExceed", async () => {
  return ''
})

export const commonreducerSlice = createSlice({
  name: 'appCommonReducers',
  initialState: {
    woCates: [],
    spinner1: false,
    enableAction: false,

    woData: [],
    spinner3: true,
    recCount: 0,
    gridSize: 0,

    getAccBalanceSpinner: true,
    getAccBalance: {},

    frbSpinner: true,
    getFRBData: [],
    getFRBReqData: [],
    frbAllGroups: [],
    frbAllRoles: [],
    frbVessels: [],
    frDetails: {},
    currentBillingPrefixLine2: "",
    currentBillingPrefixLine1: "",
    FrbBillinfoData: [],
    frbRoleSpinner: true,
    getFRBClientRoles: [],

    invoiceListSpinner: true,
    invoiceListByAgent: [],

    dloader: false,
    documentTypes: [],

    woIData: null,
    spinner4: false,

    wloader: false,
    woIdData: null,

    woIdDocs: [],
    wdloader: false,

    fileData: {},
    uploadErrMsg: '',
    woType: '',
    stype: '',
    woTypeId: null,
    floader: true,


    tokenExp: false,

    invoiceData: {},
    ispinner: false,

    woBool: false,

    fileStatus: '',
    fileExceed: false,

    bwloader: false,
    bwData: null,

    agentLoader: false,
    agentData: [],
    tabStop: false,
    selectedAgent: localStorage.getItem('agentObj') ? JSON.parse(localStorage.getItem('agentObj')) : {},
    cartItems: localStorage.getItem('addToCartItems') ? JSON.parse(localStorage.getItem('addToCartItems')) : [],
    customerEmail: localStorage.getItem('customerEmail'),
    invoiceDownloadStatus: [],
    loadingOpaqueSpinner: false,
    userAgents: [],
    displayMenuBool: false,
    contactDetals: []
  },
  reducers: {
    handleAddtoCart: (state, action) => {
      // console.log(action.payload)
      localStorage.setItem('addToCartItems', action.payload?.cartData)
      state.cartItems = localStorage.getItem('addToCartItems') ? JSON.parse(localStorage.getItem('addToCartItems')) : []
      if (action.payload?.addingStatus) {
        const toastMsg = action.payload?.addingStatus
        toast(t => (<ToastMessage t={t} message={toastMsg} status={"success"} />), {
          position: 'top-center'
        })
      }
    },
    paymentDetailsLoader: (state, action) => {
      if (action.payload) {
        state.wloader = action.payload
      }
    },
    handleCusEmailChange: (state, action) => {
      localStorage.setItem('customerEmail', action.payload)
      if (action.payload) {
        if (state.customerEmail !== action.payload) {
          localStorage.removeItem('addToCartItems')
          state.customerEmail = action.payload
          state.woData = []
          state.cartItems = []
        }
      } else {
        state.customerEmail = action.payload
        state.woData = []
        state.cartItems = []
        localStorage.removeItem('addToCartItems')
      }
    },
    loadingOpaqueSpinnerStatus: (state, action) => {
      state.loadingOpaqueSpinner = action.payload
    },
    handleEmptyUserAgents: (state, action) => {
      state.contactDetals = []
      state.userAgents = action.payload
    }
  },
  extraReducers: builder => {
    builder
      .addCase(getCompanyValue.fulfilled, (state, action) => {
        if (action.payload) {
          state.selectedAgent = action.payload
          state.cartItems = []
          localStorage.removeItem('addToCartItems')
        } else {
          state.cartItems = []
          state.selectedAgent = {}
          state.woData = []
          localStorage.removeItem('addToCartItems')
        }
      })
      .addCase(getSalesInvoicesForAgent.fulfilled, (state, action) => {
        if (action.payload) {
          state.spinner3 = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.woData = action.payload.data

          state.gridSize = action.payload.gridSize
        }
      })
      .addCase(GetSalesInvoicesCountForAgent.fulfilled, (state, action) => {
        if (action.payload) {
          state.recCount = action.payload.recCount
        }
      })
      .addCase(getInvoiceListByAgent.fulfilled, (state, action) => {
        if (action.payload) {
          state.invoiceListSpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.invoiceListByAgent = action.payload.data
        }
      })
      .addCase(getPaymentHistory.fulfilled, (state, action) => {
        if (action.payload) {
          state.spinner3 = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.woData = action.payload.data
          state.recCount = action.payload.recCount
          state.gridSize = action.payload.gridSize
        }
      })
      .addCase(getBaseWorkorderData.fulfilled, (state, action) => {
        if (action.payload) {
          state.bwloader = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.bwData = action.payload.data
        }
      })
      .addCase(UpdateWorkorder.fulfilled, (state, action) => {
        if (action.payload) {
          state.wloader = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.woIdData = action.payload.data
          state.spinner4 = action.payload.spinner
          state.woIData = action.payload.data1
        }
      })
      .addCase(GetTransactionData.fulfilled, (state, action) => {
        if (action.payload) {
          state.wloader = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.woIdData = action.payload.data
          state.spinner4 = action.payload.spinner
          state.woIData = action.payload.data1
        }
      })
      .addCase(getAccountDetailsForAgent.fulfilled, (state, action) => {
        if (action.payload) {
          state.getAccBalanceSpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.getAccBalance = action.payload.data
        }
      })
      .addCase(GetAgentDetails.fulfilled, (state, action) => {
        if (action.payload) {
          const companyData = action.payload
          if (companyData) {
            const sfCompanys = []
            if (companyData.length > 0) {
              companyData.forEach((item) => {
                if (item.customerNumber) {
                  sfCompanys.push({ value: item.customerNumber, label: `${item.customerName} ${item.customerNumber !== null ? `(${item.customerNumber})` : ''}`, name: item.customerName, agentId: item.customerNumber })
                }
              })
            }
          }
        }
      })
      .addCase(GetFRBByAgentNumber.fulfilled, (state, action) => {
        if (action.payload) {
          state.frbSpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.getFRBData = action.payload.data
        }
      })

      .addCase(GetRequestQueuebyAgentNumber.fulfilled, (state, action) => {
        if (action.payload) {
          state.frbSpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.getFRBReqData = action.payload.data?.requests
          state.currentBillingPrefixLine1 = ''
          state.currentBillingPrefixLine2 = ''
        }
      })
      .addCase(GetFRBClientRoles.fulfilled, (state, action) => {
        if (action.payload) {
          state.frbRoleSpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.getFRBClientRoles = action.payload.data
        }
      })

      .addCase(GetAllGroups.fulfilled, (state, action) => {
        if (action.payload) {
          state.frbAllGroups = action.payload.data?.groups
          state.tokenExp = action.payload.tokenExp
        }
      })
      .addCase(GetAllRoles.fulfilled, (state, action) => {
        if (action.payload) {
          state.frbAllRoles = action.payload.data?.roles
          state.tokenExp = action.payload.tokenExp
        }
      })
      .addCase(GetVesselsByAgentId.fulfilled, (state, action) => {
        if (action.payload) {
          state.frbVessels = action?.payload?.data?.vessels
          state.tokenExp = action.payload.tokenExp
        }
      })

      .addCase(GetBilltoPartyInformation.fulfilled, (state, action) => {
        if (action.payload) {
          state.FrbBillinfoData = action.payload.data?.billToParty
          state.tokenExp = action.payload.tokenExp
        }
      })
      .addCase(GetFRPDetails.fulfilled, (state, action) => {
        if (action.payload) {
          state.frDetails = action.payload.data
          state.currentBillingPrefixLine1 = action.payload.data.currentBillingPrefixLine1
          state.currentBillingPrefixLine2 = action.payload.data.currentBillingPrefixLine2
          state.tokenExp = action.payload.tokenExp
        }
      })

      .addCase(ImpersonateUser.fulfilled, (state, action) => {
        if (action.payload) {
          state.loadingOpaqueSpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.userAgents = action.payload.data
        }
      })
      .addCase(getAgentDetailsByAgentNo.fulfilled, (state, action) => {
        if (action.payload) {
          state.agentLoader = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.agentData = action.payload.data
        }
      })

      .addCase(invoiceDownloadProgress.fulfilled, (state, action) => {
        if (action.payload) {
          // state.total = action.payload.total
          // state.counter = action.payload.counter
          state.progress = action.payload.progress
          // state.fileCount = action.payload.fileCount
          state.invoiceDownloadStatus = (action.payload.invoiceDownloadStatus ? action.payload.invoiceDownloadStatus : [])
          state.fileStatus = action.payload.fileStatus
        }
      })
      .addCase(getStepNameStatus.fulfilled, (state) => {
        state.wdloader = false
        state.dloader = false
        // state.wloader = false
        state.cloader = false
        state.ispinner = false
      })
      .addCase(displayMenu.fulfilled, (state, action) => {
        state.displayMenuBool = action.payload
      })
      .addCase(getClearStatus.fulfilled, (state) => {
        state.wdloader = false
        state.dloader = false
        state.wloader = false
        state.cloader = false
        state.ispinner = false
        state.woIData = null
        state.spinner3 = false
        state.bwloader = false
        state.bwData = null
      })
      .addCase(getClearPaymentStatus.fulfilled, (state) => {
        state.billedVesselSpin = false
        state.wloader = false
        state.ispinner = false
        state.spinner4 = false
        state.woIData = null
        state.woIdData = []
      })
      .addCase(getWoLoading.fulfilled, (state, action) => {

        state.spinner3 = action.payload
        // state.getAccBalanceSpinner = false
      })
      .addCase(tabStopper.fulfilled, (state, action) => {

        state.tabStop = action.payload
        // state.getAccBalanceSpinner = false
      })

      .addCase(getClearStore.fulfilled, (state) => {
        state.woIdData = []
        state.woIData = null
        state.checkwoData = null
      })
      .addCase(getClearStoreData.fulfilled, (state) => {
        state.checkwoData = null
      })
      .addCase(getClearFileData.fulfilled, (state) => {
        state.fileData = {}
        state.floader = true
      })
      .addCase(removeneedinfodata.fulfilled, (state) => {
        state.needcomment = ''
        state.needstatus = ''
      })
      .addCase(getFileExceed.fulfilled, (state) => {
        state.fileExceed = false
      })
      .addCase(GetContactDetails.fulfilled, (state, action) => {
        if (action.payload) {
          state.contactDetals = action.payload.data
          state.tokenExp = action.payload.tokenExp
        }
      })
  }
})
export const { handleAddtoCart, handleCusEmailChange, loadingOpaqueSpinnerStatus, handleEmptyUserAgents, paymentDetailsLoader } = commonreducerSlice.actions
export default commonreducerSlice.reducer
